import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import "./LearProgTab.css";
import ExpePracData from "./ExpePracData.json";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Entry-level" {...a11yProps(0)} />
          <Tab label="Experienced-practitioners" {...a11yProps(1)} />
          <Tab label="Executives" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <p className="heading-text">Entry-level</p>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <div className="lear-stra-wrap">
          {ExpePracData.map((item) => {
            return (
              <div key={item.id} className="lear-stra-row">
                <div className="lear-stra-box">
                  <img
                    src={item.image}
                    alt="icons"
                    className="lear-stra-icons"
                  />
                  <p>{item.para}</p>
                </div>
              </div>
            );
          })}
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <p className="heading-text">Executives</p>
      </CustomTabPanel>
    </Box>
  );
}
